import { render, staticRenderFns } from "./dialog-multi-checkbox-group.vue?vue&type=template&id=6410f174&scoped=true&"
import script from "./dialog-multi-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./dialog-multi-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./dialog-multi-checkbox-group.vue?vue&type=style&index=0&id=6410f174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6410f174",
  null
  
)

export default component.exports